import { kgToRoundedLb } from './weekly-net-down';
/**
 * Where a saved weigh-in came from.
 * `scale` is a Bluetooth scale reading. `manual` is a weight someone typed.
 * `api` is a weight posted by an import or other API client.
 * Distinct from exercise `exerciseSource` and from per-session `source`.
 */
export const WEIGH_IN_SOURCES = ['scale', 'manual', 'api'];
/**
 * Renpho/Lefu scales convert kg→lb for the LCD with integer floor math on
 * 0.01-kg raw units: floor(raw × 22046 / 100000) / 10.
 * Float round with 2.20462 can be 0.1 lb high (104.10 kg → 229.4 on the
 * scale, 229.5 with ordinary rounding).
 */
const KG_RAW_TO_LB_NUMERATOR = 22046;
const KG_RAW_TO_LB_DENOMINATOR = 100000;
/** Match Renpho/Lefu LCD lb display from 0.01-kg raw (centigrams). */
export function kgRawCentigramsToLbDisplay(rawCentigrams) {
    const lbTenths = Math.floor((rawCentigrams * KG_RAW_TO_LB_NUMERATOR) / KG_RAW_TO_LB_DENOMINATOR);
    return lbTenths / 10;
}
/** Imperial weight display aligned with Renpho/Lefu scale LCD rounding. */
export function kgToLbForScaleDisplay(kg) {
    const rawCentigrams = Math.round(kg * 100);
    return kgRawCentigramsToLbDisplay(rawCentigrams);
}
export function isScaleWeighInSource(source) {
    return source === 'scale';
}
/**
 * Pounds for a saved weigh-in.
 * A scale row matches the scale screen. Manual, API, and legacy rows
 * (no source) use ordinary half-up rounding.
 */
export function displayWeightLb(kg, source) {
    if (isScaleWeighInSource(source)) {
        return kgToLbForScaleDisplay(kg);
    }
    return kgToRoundedLb(kg);
}
